export default __webpack_public_path__ + "static/char-47-anr-9a260bcf135e21e54580fbbaf4887c66.gif";